import { render, staticRenderFns } from "./HelpBalloon.vue?vue&type=template&id=271d20e4&"
import script from "./HelpBalloon.vue?vue&type=script&lang=ts&"
export * from "./HelpBalloon.vue?vue&type=script&lang=ts&"
import style0 from "./HelpBalloon.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports